import { useState, useCallback } from 'react';
import { useAppData } from './store.js';
import NavBar from './components/NavBar.jsx';
import Toast from './components/Toast.jsx';
import { ConfirmProvider } from './components/ConfirmDialog.jsx';

import Dashboard from './screens/Dashboard.jsx';
import Transactions from './screens/Transactions.jsx';
import Forecast from './screens/Forecast.jsx';
import Trends from './screens/Trends.jsx';
import Manage from './screens/Manage.jsx';
import Settings from './screens/Settings.jsx';

export default function App() {
  const { state, lookups, mutate, generic, reload, loadFullHistory } = useAppData();
  const [tab, setTab] = useState('dashboard');
  const [toast, setToast] = useState(null);

  const showToast = useCallback((t) => setToast(t), []);
  const dismissToast = useCallback(() => setToast(null), []);

  if (state.loading) {
    return (
      <div className="full-spinner">
        <div className="spinner" />
        <div>Loading…</div>
      </div>
    );
  }

  if (state.error) {
    return (
      <div className="screen">
        <h1>Connection error</h1>
        <div className="card">
          <div className="muted" style={{ marginBottom: 12 }}>{state.error}</div>
          <button className="primary" onClick={reload}>Retry</button>
        </div>
      </div>
    );
  }

  const screenProps = { state, lookups, mutate, generic, reload, loadFullHistory, showToast };

  return (
    <ConfirmProvider>
      <div className="app-shell">
        {tab === 'dashboard'    && <Dashboard {...screenProps} />}
        {tab === 'transactions' && <Transactions {...screenProps} />}
        {tab === 'forecast'     && <Forecast {...screenProps} />}
        {tab === 'trends'       && <Trends {...screenProps} />}
        {tab === 'manage'       && <Manage {...screenProps} />}
        {tab === 'settings'     && <Settings {...screenProps} />}
        <NavBar active={tab} onChange={setTab} />
        <Toast toast={toast} onDismiss={dismissToast} />
      </div>
    </ConfirmProvider>
  );
}
